let colors = [
  '#7ab956',
  '#fbba39'
];

export default [
  {
    type: 'line',
    itemStyle: {
      normal: {
        color: colors[0],
        lineStyle: {
          color: colors[0]
        }
      }
    }
  },
  {
    type: 'line',
    itemStyle: {
      normal: {
        color: colors[1],
        lineStyle: {
          color: colors[1]
        }
      }
    }
  }
]